import { render } from "./TabMiembrosEquipo.vue?vue&type=template&id=79d9198b"
import script from "./TabMiembrosEquipo.vue?vue&type=script&lang=js"
export * from "./TabMiembrosEquipo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__